export default {
    local: {
        landing_page_url: "https://acn-my-morri.appspot.com",
        client_id: "858113026121-ost1pr84avr3tlnroahnaiidpr369mq9.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        stub_oauth: true,
        ga_ua: "UA-91860945-5",
        ga_debug: true
    },
    localGAE: {
        landing_page_url: "https://acn-my-morri.appspot.com",
        client_id: "858113026121-ost1pr84avr3tlnroahnaiidpr369mq9.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        ga_ua: "",
    },
    dev: {
        landing_page_url: "https://acn-my-morri.appspot.com",
        client_id: "858113026121-ost1pr84avr3tlnroahnaiidpr369mq9.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        ga_ua: "UA-91860945-5",
    },
    qa: {
        landing_page_url: "https://acn-my-morri-qa.appspot.com",
        client_id: "858113026121-ost1pr84avr3tlnroahnaiidpr369mq9.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        ga_ua: "UA-91860945-6",
    },
    staging: {
        landing_page_url: "https://acn-my-morri-staging.appspot.com",
        client_id: "858113026121-ost1pr84avr3tlnroahnaiidpr369mq9.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk"
    },
    preprod: {
        landing_page_url: "https://my-morri-pre.appspot.com",
        client_id: "1057010016867-jdo8rafcpijmnce7f3o7s2pnm3mm2u67.apps.googleusercontent.com",
        email_domain: "test.morrisonsplc.co.uk",
        ga_ua: "UA-91860945-7"
    },
    prod: {
        landing_page_url: "https://www.mymorri.com",
        client_id: "1073181092632-fsbvd4difvksjgr3lkmi0ds0p0mv1r7v.apps.googleusercontent.com",
        email_domain: "morrisonsplc.co.uk",
        ga_ua: "UA-91860945-8",
    }

}[process.env.REACT_APP_ENV]



// WEBPACK FOOTER //
// ./src/config.js